import { showMicroComponentsFeatureFlag } from "@utils/default";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useContext, useState } from "react";

import { UserContext } from "@/context/UserContext";

import { MicrocopyComponentProps } from "../StickyBar/types";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "../ui/Button/Button";

export const MicrocopyComponent: React.FC<MicrocopyComponentProps> = (props) => {
  const [visible, setVisible] = useState(true);
  const { setIsDialogueOpen } = useContext(UserContext);
  const router = useRouter();
  const locale = useLocale();
  if (!visible) return null;
  if (!props.isStickybar)
    return showMicroComponentsFeatureFlag ? (
      <div
        className={`w-full ${props?.backgroundColor ? "border border-gray-20" : ""} p-[4px] mt-[10px] rounded`}
        style={{ backgroundColor: props?.backgroundColor || "" }}
      >
        {props.title && (
          <div className="flex justify-between items-center mb-2 text-black-0">
            <p className="font-primary font-medium text-[12px] uppercase pl-[8px] mt-[4px]">{props.title}</p>
            {props?.isCloseable && (
              <button
                onClick={() => {
                  setVisible(false);
                  if (props.resetMicrocopyState) props.resetMicrocopyState();
                }}
                className="font-primary font-medium text-xs uppercase pl-[8px] pr-[8px] mt-[4px]"
                aria-label="Close"
              >
                ✕
              </button>
            )}
          </div>
        )}
        {props.subTitle && <p className="font-secondary font-medium text-[12px] pl-[8px] text-black-0 mb-2">{props.subTitle}</p>}
        {props?.link && (
          <p className={`font-secondary font-medium text-[12px] pl-[8px] mt-[${props?.backgroundColor ? "8px" : "4px"}] text-black-0`}>
            <span>{props?.linkLabel}</span>
            <span>
              <Button
                className={`text-[12px] font-secondry font-medium underline pl-[8px]`}
                variant={ButtonVariant.TERTIARY}
                size={ButtonSize.SMALL}
                theme={ButtonTheme.BLACK}
                href={props?.link?.id}
                onClick={(e) => {
                  e.preventDefault();
                  if (props?.link?.link?.url.includes("projects")) {
                    router.push(`/${locale}/${props?.link?.link?.url}`);
                  }
                }}
              >
                {props?.link?.label}
              </Button>
            </span>
          </p>
        )}
      </div>
    ) : (
      ""
    );

  return showMicroComponentsFeatureFlag ? (
    <div
      className="fixed bottom-[80px] p-[8px] box-material-tertiary backdrop-blur-md left-3/4 transform -translate-x-1/2 z-50 shadow-lg rounded-lg w-[90%] md:w-[410px]"
      style={{ backgroundColor: props?.backgroundColor || "" }}
    >
      <div className="flex justify-between items-center mb-2 text-black-0">
        <p className="font-primary font-medium text-[12px] uppercase pl-[4px] mt-[8px]">{props.title}</p>
        <button
          onClick={() => {
            setVisible(false);
            if (props.resetMicrocopyState) props.resetMicrocopyState();
          }}
          className="font-primary font-medium pr-[8px] text-[12px] uppercase pl-[4px] mt-[8px]"
          aria-label="Close"
        >
          ✕
        </button>
      </div>
      <p className="font-secondary text-[12px] pl-[4px] mt-[8px] text-black-0 mb-2">{props.subTitle}</p>
      <p className="font-secondary text-[12px] pl-[4px] pr-[4px] mt-[8px] text-black-0">
        <span className="pr-[8px]">{props?.linkLabel}</span>
        <span>
          <Button
            className={`text-[12px] font-secondary font-medium underline`}
            variant={ButtonVariant.TERTIARY}
            size={ButtonSize.SMALL}
            theme={ButtonTheme.BLACK}
            // href={props.link.id}
            onClick={() => {
              setIsDialogueOpen(true);
            }}
          >
            {props?.link?.label}
          </Button>
        </span>
      </p>
    </div>
  ) : (
    ""
  );
};
